<div class="modal-overlay" *ngIf="visible">
  <div class="modal-box">
    <ng-container *ngIf="status === 'loading'">
      <div class="spinner"></div>
      <p class="modal-message">{{ message || 'Procesando...' }}</p>
    </ng-container>

    <ng-container *ngIf="status === 'success'">
      <div class="status-icon success">✓</div>
      <p class="modal-message">{{ message || 'Completado con éxito' }}</p>
      <div class="btn-box">
        <button class="btn btn-primary remove-btn" (click)="close()">{{'CLOSE' | translate}}</button>
      </div>
    </ng-container>

    <ng-container *ngIf="status === 'error'">
      <div class="status-icon error">!</div>
      <p class="modal-message">{{ message || 'Ha ocurrido un error' }}</p>
      <div class="btn-box">
        <button class="btn btn-primary remove-btn" (click)="close()">{{'CLOSE' | translate}}</button>
      </div>
    </ng-container>
  </div>
</div>
